import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spin, Typography } from 'antd';

const { Text } = Typography;

const DeleteSocialMedia = ({
  onClose,
  onSubmit,
  title,
  isLoading,
  isError,
  errorMsg,
}) => (
  <Modal title={title} visible={true} onCancel={onClose} onOk={onSubmit}>
    {isLoading && <Spin size="large" />}
    {isError && <Text type="danger">{errorMsg}</Text>}
  </Modal>
);

DeleteSocialMedia.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string.isRequired,
};

export default DeleteSocialMedia;
